// src/services/documentService.js
const RAW_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const API_URL = RAW_API_URL.endsWith('/api')
  ? RAW_API_URL
  : `${RAW_API_URL.replace(/\/+$/, '')}/api`;

const documentService = {
  // Obtener todos los documentos
  async getDocuments(token, params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    const url = `${API_URL}/documents${queryParams ? `?${queryParams}` : ''}`;
    
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener documentos');
    }

    return await response.json();
  },

  // Obtener estadísticas
  async getStats(token) {
    const response = await fetch(`${API_URL}/documents/stats`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Unable to retrieve statistics');
    }

    return await response.json();
  },

  // Subir documento
  async uploadDocument(formData, token) {
    const response = await fetch(`${API_URL}/documents/upload`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        // NO incluir Content-Type para FormData
      },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al subir documento');
    }

    return await response.json();
  },

  // Descargar documento
  async downloadDocument(documentId, token) {
    const response = await fetch(`${API_URL}/documents/download/${documentId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Error al descargar documento');
    }

    return await response.blob();
  },

  // Eliminar documento
  async deleteDocument(documentId, token) {
    const response = await fetch(`${API_URL}/documents/${documentId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al eliminar documento');
    }

    return await response.json();
  },
};

export default documentService;
